import type {
  IArchiveRequestPayload,
  IDeleteRequestPayload,
  IPublishRequestPayload,
  IRenameRequestPayload,
} from './types';

const DOCUMENT = 'RATE_ENGINE_MUTATIONS_';

const actions = {
  RENAME_REQUEST: `${DOCUMENT}RENAME_REQUEST`,
  RENAME_SUCCESS: `${DOCUMENT}RENAME_SUCCESS`,
  RENAME_ERROR: `${DOCUMENT}RENAME_ERROR`,

  DELETE_REQUEST: `${DOCUMENT}DELETE_REQUEST`,
  DELETE_SUCCESS: `${DOCUMENT}DELETE_SUCCESS`,
  DELETE_ERROR: `${DOCUMENT}DELETE_ERROR`,

  ARCHIVE_REQUEST: `${DOCUMENT}ARCHIVE_REQUEST`,
  ARCHIVE_SUCCESS: `${DOCUMENT}ARCHIVE_SUCCESS`,
  ARCHIVE_ERROR: `${DOCUMENT}ARCHIVE_ERROR`,

  PUBLISH_REQUEST: `${DOCUMENT}PUBLISH_REQUEST`,
  PUBLISH_SUCCESS: `${DOCUMENT}PUBLISH_SUCCESS`,
  PUBLISH_ERROR: `${DOCUMENT}PUBLISH_ERROR`,

  CLEAR_STORE: `${DOCUMENT}CLEAR_STORE`,

  renameRequest: (payload: IRenameRequestPayload) => ({ type: actions.RENAME_REQUEST, payload }),
  renameSuccess: () => ({ type: actions.RENAME_SUCCESS }),
  renameError: () => ({ type: actions.RENAME_ERROR }),

  deleteRequest: (payload: IDeleteRequestPayload) => ({ type: actions.DELETE_REQUEST, payload }),
  deleteSuccess: () => ({ type: actions.DELETE_SUCCESS }),
  deleteError: () => ({ type: actions.DELETE_ERROR }),

  archiveRequest: (payload: IArchiveRequestPayload) => ({ type: actions.ARCHIVE_REQUEST, payload }),
  archiveSuccess: () => ({ type: actions.ARCHIVE_SUCCESS }),
  archiveError: () => ({ type: actions.ARCHIVE_ERROR }),

  publishRequest: (payload: IPublishRequestPayload) => ({ type: actions.PUBLISH_REQUEST, payload }),
  publishSuccess: () => ({ type: actions.PUBLISH_SUCCESS }),
  publishError: () => ({ type: actions.PUBLISH_ERROR }),

  clearStore: () => ({ type: actions.CLEAR_STORE }),
};

export default actions;
